import { api } from "@/lib/api";

export type StatusPodobnosti = "podoban" | "nepodoban";
export type StanjeRazloga = "nedostaje_podatak" | "istekao" | "nevaljan";

export interface RazlogPodobnosti {
  source: string;
  obligation: string;
  state: StanjeRazloga;
  due_on: string | null;
}

export interface Podobnost {
  worker_id: string;
  status: StatusPodobnosti;
  reasons: RazlogPodobnosti[];
}

export interface PojedinostiPodobnosti {
  deadlines?: Rok[];
  worker_id: string;
  worker_name: string;
  eligibility: Podobnost | null;
}

export interface SkupnaPodobnost {
  worker_id: string;
  worker_name: string;
  job_position: string | null;
  eligibility: Podobnost;
}

export interface Rok {
  worker_id: string;
  worker_name: string;
  source: string;
  obligation: string;
  item_type: string;
  due_on: string;
  days_until_due: number;
  blocking: boolean;
  alert_thresholds: number[];
}

export async function dohvatiRokove(
  days: number,
  signal?: AbortSignal,
): Promise<Rok[]> {
  // The same window backwards as forwards: the ISTEKLO section is about what
  // lapsed inside the period being looked at, not about everything that ever
  // lapsed.
  const response = await api.get<Rok[]>("/eligibility/pregled", {
    params: { days, expired_days: days },
    signal,
  });
  return response.data;
}

export async function dohvatiPodobnostRadnika(
  radnikId: string,
  signal?: AbortSignal,
): Promise<PojedinostiPodobnosti> {
  const response = await api.get<PojedinostiPodobnosti>(
    `/radnici/${radnikId}/eligibility`,
    { signal },
  );
  return response.data;
}

export async function dohvatiStatusePodobnosti(
  signal?: AbortSignal,
): Promise<SkupnaPodobnost[]> {
  const response = await api.get<SkupnaPodobnost[]>("/eligibility/statusi", {
    signal,
  });
  return response.data;
}
